export default __webpack_public_path__ + "static/media/35.594a2d83.jpg";